const FlowNumbersBox = ({
  index,
  isLetter,
  baseSequence,
  isNormal,
  number,
  baseNumber,
  color,
}) => {
  if (!index) index = 0;

  const dynamicSequence = `${baseSequence}${
    baseNumber ? baseNumber + index : 1 + index
  }`;

  const getLetterFromIndex = (index) => {
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return alphabet[index % 26];
  };

  const generateSequence = (index) => {
    if (index) {
      return `${baseSequence}${getLetterFromIndex(index)}`;
    } else {
      return `${baseSequence}A`;
    }
  };

  return (
    <h5
      style={{
        color: color ? color : "white",
        fontWeight: 400,
        fontSize: "11px",
        marginLeft: "20px",
      }}
    >
      {!isLetter && !isNormal
        ? dynamicSequence
        : isLetter
        ? generateSequence(index)
        : number}{" "}
    </h5>
  );
};

export default FlowNumbersBox;
